import { Instance, SnapshotOut, types } from "mobx-state-tree";
import { BoundedNameModel } from "../../models/BoundedNameModel";

export const EmailTemplateModel = types.model("EmailTemplateModel", {
  id: types.string,
  templateName: BoundedNameModel,
  projectId: types.maybeNull(types.string),
  projectName: types.maybe(types.string),
});

export const createEmailTemplateModel = (
  emailTemplate: SnapshotOut<typeof EmailTemplateModel>,
): Instance<typeof EmailTemplateModel> =>
  EmailTemplateModel.create(emailTemplate);
